export const calculateYData = (x, position) => {
    const { strike, premium, buy_sell, call_put_stock } = position;
    const numPremium = Number(premium);
    const numStrike = Number(strike);

    if (buy_sell === "buy" && call_put_stock === "call") {
        return x < numStrike ? -numPremium : -numPremium + x - numStrike;
    }
    if (buy_sell === "sell" && call_put_stock === "call") {
        return x < numStrike ? numPremium : numPremium - x + numStrike;
    }
    if (buy_sell === "buy" && call_put_stock === "put") {
        return x > numStrike ? -numPremium : -numPremium + numStrike - x;
    }
    if (buy_sell === "sell" && call_put_stock === "put") {
        return x > numStrike ? numPremium : numPremium - numStrike + x;
    }
    if (buy_sell === "buy" && call_put_stock === "stock") {
        return x - numPremium;
    }
    if (buy_sell === "sell" && call_put_stock === "stock") {
        return numPremium - x;
    }
    return 0;
};
